<template>
  <div>
    <div class="columns">
      <div class="column is-full-mobile">
        <h4 class="is-size-5 has-text-weight-semibold">{{ user.name }} {{ user.surname }}</h4>
        <p>{{ user.email }}</p>

        <div class="tags">
          <span class="tag is-light">{{ $t("misc.status") }}: {{ userStatus }}</span>
          <span class="tag is-light">{{ $t("misc.role") }}: {{ userRole }}</span>
        </div>
      </div>

      <div class="column is-one-quarter is-full-mobile is-flex is-align-items-center is-justify-content-flex-end">
        <button @click="$emit('deleteUser', user)" class="button is-danger">{{ $t("misc.delete") }}</button>
      </div>
    </div>

    <hr />
  </div>
</template>

<script>

export default {
  name: "UserRow",
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    userStatus: function () {
      if (this.user.status == null) return "";

      return this.user.status.charAt(0).toUpperCase() + this.user.status.slice(1);
    },
    userRole: function () {
      return this.user.role.charAt(0).toUpperCase() + this.user.role.slice(1);
    }
  }
};

</script>

<style scoped>
.tags {
  margin-top: 0.5rem;
}

@media only screen and (max-width: 768px) {
  .button {
    width: 100%;
  }
}
</style>